import React from 'react'
import { Loading, Text } from '@workwhile/ui'
import { useUserProfileById, useUserW2I9Form } from 'queries/user'
import { I9Form } from '../I9Form'

export function DetailView({ userId }: { userId: number }) {
  const { data: user, isLoading: isLoadingUserProfile } =
    useUserProfileById(userId)
  const { data: userW2I9Form, isLoading: isLoadingUserW2I9Form } =
    useUserW2I9Form(userId)

  if (isLoadingUserProfile || isLoadingUserW2I9Form) {
    return <Loading />
  }

  if (!user || !userW2I9Form) {
    return <Text>No data available</Text>
  }

  return <I9Form user={user} data={userW2I9Form} showProcessForm />
}
